export default "__VITE_ASSET__Db_U7_H6__"